// extracted by mini-css-extract-plugin
export default {"container":"styles_container__AydrO","atWork":"styles_atWork__y1FLO","containerLeft":"styles_containerLeft__s-cL5","containerRigth":"styles_containerRigth__STQZN"};